<template>
  <div class="activities">
    <div class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-1" style="color: white !important;">Activity</h1>
          <h5 class="subtitle is-size-5" style="color: white !important;">Scorecards submitted (last 10 days)</h5>        
        </div>
      </div>
    </div>
    <div class="container">
<!--
      <div v-if="ticker_data_round_robin != null">
        <VTextMarquee :speed="85">{{ ticker_data_round_robin.ticker}}</VTextMarquee>
      </div>

      <div v-if="ticker_data_solo != null">
        <VTextMarquee :speed="85">{{ ticker_data_solo.ticker}}</VTextMarquee>
      </div>
-->
      <br/>
      <div class="box" v-show="showError">
        <article class="message is-danger">
          <div class="message-body">
              {{ errorMessage }}
          </div>
        </article>
      </div>
      <div class="box">
        <div class="columns activity-header">
          <div class="column is-3">
            Date Time (UTC)
          </div>
          <div class="column is-2">
            Game Type
          </div>
          <div class="column is-3">
            Title
          </div>
          <div class="column is-3">
            Subscriber
          </div>
          <div class="column is-1">
          </div>
        </div>
        <div v-if="pleaseWait"><p>Please wait...</p></div>
        <div v-for="(activity, index) in activities" :key="activity._id">
          <div class="columns activity">
            <div class="column is-3">
              <a v-on:click="showScorecard(activity)">
                {{ activity.dateTimeStamp | formatDateTime }}
              </a>
              <div style="font-size: 0.8em;">
                <span v-if="activity.gameType == GameType.ROUNDROBIN || activity.gameType == GameType.TOURNAMENT">
                  <a v-on:click="showSummaryModal(activity)">
                    <br/><span><i class="fa-solid fa-clipboard-list"></i>Summary</span>
                  </a>
                  &nbsp;
                  <a title="Share Scorecard" v-on:click="shareScorecard(activity)"><i class="fas fa-share"></i>Share</a>
                  &nbsp;
                  <a title="Email Scorecard" v-on:click="emailScorecard(activity)"><i class="fas fa-envelope"></i>Email</a>
                </span> 
              </div>
            </div>
            <div class="column is-2">
              {{ activity.gameType }}
            </div>
            <div class="column is-3">
              {{ activity.title }}
            </div>
            <div class="column is-3">
              {{ activity.subscriber }}
            </div>
            <div class="column is-1">
              <i class="fas fa-trash has-text-danger" v-on:click="deleteScorecard(activity, index)" title="DELETE"></i>
            </div>
          </div>
        </div>
      </div>
      <br/>
      <br/>
    </div>
  </div>
</template>

<style>
.newLink {
  color: red;
  font-weight: bold;
}
</style>

<script>
import axios from "axios";
import { VTextMarquee } from 'vue-text-marquee';
import { GameType } from '@/enum/gameType.js';

export default {
  name: 'activity',
    components : {
      VTextMarquee: VTextMarquee
    },
    computed: {
    },
    data () {
      return {
        GameType,
        debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
        publicPath: process.env.BASE_URL,
        ticker_data_solo: null,
        ticker_data_round_robin: null,
        activities: [],
        errorMessage: '',
        showError: false,
        pleaseWait: true
      }
    },
    methods:{
      shareScorecard: function(scorecard) {
        //alert(scorecard._id);
        window.open('/summary/' + scorecard._id);
      },
      emailScorecard: function(scorecard) {
        var email_string = "mailto:?subject=Scorecard&body=Your game summary is here: https://axes2.ca/summary/" + scorecard._id + ".";
        window.open(email_string);
      },
      getTickerDataSolo() {
          //console.log("get ticker data solo");
          var url = (this.debugMode ? "http://localhost:8080/ticker/solo" : "https://axes2api.azurewebsites.net/ticker/solo")
          axios.get(url, {})
          .then((response) => {
              //console.log(response.data)
              this.ticker_data_solo = response.data;
          }, (error) => {
              //console.log(error);
          });
      },
      getTickerDataRoundRobin() {
          //console.log("get ticker data round-robin");
          var url = (this.debugMode ? "http://localhost:8080/ticker/roundrobin" : "https://axes2api.azurewebsites.net/ticker/roundrobin")
          axios.get(url, {})
          .then((response) => {
              //console.log(response.data)
              this.ticker_data_round_robin = response.data;
          }, (error) => {
              //console.log(error);
          });
      },
      showScorecard: function(scorecard) {
        //console.log("showScorecard");
        //console.log(scorecard);

        var url = (this.debugMode ? "http://localhost:8080/scorecard/" : "https://axes2api.azurewebsites.net/scorecard/")
        url += scorecard._id;

        var token = this.$parent.getApiToken();

        axios.get(url,{
            headers: {
                authorization: token
            }
        })
        .then((response) => {
          //console.log(response.data);
          this.$parent.showModal(response.data);
        }, (error) => {
          alert(error);
        });

      },
      //duplicated in Profile.vue
      showSummaryModal: function(scorecard) {
        //console.log("showScorecard");
        //console.log(scorecard);

        var url = (this.debugMode ? "http://localhost:8080/scorecard/" : "https://axes2api.azurewebsites.net/scorecard/")
        url += scorecard._id;

        var token = this.$parent.getApiToken();

        axios.get(url,{
            headers: {
                authorization: token
            }
        })
        .then((response) => {
          //console.log("showSummaryModal - got data",response.data);
          this.$parent.showSummaryModal(response.data);
        }, (error) => {
          alert(error);
        });

      },
      deleteScorecard: function(scoresheet, index) {
        if (confirm("Are you sure you want to delete this scorecard submitted on " + scoresheet.dateTimeStamp + " by " + scoresheet.subscriber + "?")) {
          var scorecardId = scoresheet._id;

          //console.log("deleteScoresheet " + scorecardId);
          //console.log(scoresheet);

          var url = (this.debugMode ? "http://localhost:8080/scorecard/" : "https://axes2api.azurewebsites.net/scorecard/")
          url += scorecardId;
          //console.log("url: " + url);
          
          var token = this.$parent.getApiToken();

          axios.delete(url, {
            headers: {
              authorization: token
            },
            data: {

            }
          })
          .then((response) => {
            //alert('Scorecard Deleted.');
            //console.log(response);
            
            this.activities.splice(index, 1);
            
          }, (error) => {
            alert("Error deleting scorecard.");
            //console.log(error);
          });
          
        }
      },
      getActivities: function () {
        var url = (this.debugMode ? "http://localhost:8080/latestactivity/10" : "https://axes2api.azurewebsites.net/latestactivity/10")
        var token = this.$parent.getApiToken();
        axios.get(url,{
              headers: {
                  authorization: token
              }
          })
          .then((response) => {
            if (response.data.error != null) {
              this.errorMessage = response.data.error;
              this.showError = true;
              this.pleaseWait = false;
            } else {
              this.activities = response.data; 
              this.pleaseWait = false;
            }
          }, (error) => {
            this.errorMessage = error;
            this.showError = true;
            this.pleaseWait = false;
          });
        },
      isAdmin() {
          return this.$parent.isAdmin();
      }
    },
    mounted(){
      //console.log("process.env.VUE_APP_DEBUG_MODE: " + process.env.VUE_APP_DEBUG_MODE);
      if (this.isAdmin()) {
        setTimeout(() => {
          this.getActivities();
          //this.getTickerDataSolo();
          //this.getTickerDataRoundRobin();
        }
          , 1000);
      } else {
        alert("You don't have permission to access this page.");
      }
    }
}
</script>

<style lang="scss">
.running {
  font-size: 6em !important;
  color: white;
}
</style>
<style lang="scss" scoped>
  .hero {
    background-color: black;
  }
  .box {
    font-family: Verdana;
  }
  .activities {

  }
  .activity-header {
    background-color: black;
    color: white;
    font-size: 1.5em;
    border-radius: 6px;
  }
  .activity {
    border-top: solid gray 1px;
    padding: 10px;
  }
  .blink {
    color: #97312d;
    animation: blink-animation 1s steps(5, start) infinite;
    -webkit-animation: blink-animation 1s steps(5, start) infinite;
  }
  @keyframes blink-animation {
    to {
      visibility: hidden;
    }
  }
  @-webkit-keyframes blink-animation {
    to {
      visibility: hidden;
    }
  }
</style>